(async () => {
  class KlujoSnippet {
    css = `
        body.game-open {
          width: 100% !important;
          height: 100% !important;
          position: fixed;
          top: 0;
          overflow: hidden !important;
        }

        .game-frame {
          background-color: transparent;
          filter: blur(25px) brightness(.1) drop-shadow(2px 4px 6px black);
          position: fixed;
          border: none;
          opacity: .001;
          pointer-events: none;
          width: 100%;
          height: 100%;
          transform: scale(2);
          transition: all .6s ease-in-out;
        }

        body.game-open .game-frame {
          background-color: transparent;
          z-index: 99997;
          border: none;
          opacity: 1 !important;
          pointer-events: all;
          transform: scale(1);
          filter: blur(0);
          overflow: hidden;
        }

        .close-game {
          z-index: 100000;
          position: fixed;
          right: 2%;
          top: 2%;
          width: 18px;
          cursor: pointer;
          display: none;
        }

        body.game-open .close-game {
          display: block;
        }

        .close-game > img {
          width: 2em;
        }

        .toggl-button {
          background-color: #39abce;
          color: #fff;
          border-radius: 30px;
          height: 40px;
          min-width: 40px;
          display: inline-flex;
          align-items: center;
          position: fixed;
          text-align: center;
          font-size: 16px;
          padding: 15px;
          border: 0;
          outline: 0;
          user-select: none;
          cursor: pointer;
          white-space: nowrap;
          bottom: 20px;
          left: 20px;
          transition: all .5s ease-out;
        }

        .toggl-button img + span {
          margin-left: 15px;
        }

        .OpenButton img {
          max-width: 40px;
        }

        .closeButton {
          z-index: -1;
          padding: 0;
        }

        .closeButton img {
          max-width: 20px;
          margin: 0 auto;
          filter: invert(1);
        }

        .reward-popup.hidden {
          opacity: .1;
          height: 0;
          filter: blur(25px);
        }

        .reward-popup {
          z-index: 99998;
          position: fixed;
          bottom: 70px;
          left: 21px;
          max-width: 90wh;
          height: calc(100% - 120px);
          max-height: 600px;
          box-shadow: 0 0 80px 0 rgba(0,0,0,.3);
          overflow: auto hidden;
          transition: all .5s ease-in-out;
          border-radius: 20px;
        }

        .reward-popup iframe {
          height: 100%;
          width: 100%;
          border: none;
        }

        .ql-align-center {
          margin: 0 !important;
        }

        .embedded-klujo {
          width: 100%;
        }

        @media only screen and (max-width: 576px) {
          .game-frame {
            background-color: transparent;
            border-radius: 0;
            width: 100vw;
            height: 100vh;
            left: -100%;
            border-radius: 0;
          }

          .reward-popup {
            transform: scale(1.1);
            transform-origin: bottom left;
          }

          body.game-open .game-frame {
            left: 0;
            top: 0;
          }

          .close-game {
            right: 10px;
            top: 10px;
            width: 30px;
          }
        }
      `
    urls = {
      domain: import.meta.env.VITE_BASE_URL,
      api: import.meta.env.VITE_BASE_URL + import.meta.env.VITE_API_BASE_PATH,
      media: import.meta.env.VITE_MEDIA_BASE_URL,
      embed: import.meta.env.VITE_PAGE_EMBEDDER_URL
    }
    dom = {
      frame: document.createElement('iframe'),
      reward: document.createElement('div'),
      root: document.querySelector('#klujo-script'),
      top: document.body,
      close: document.createElement('div'),
    }
    vars = {
      viewport: document.querySelector('meta[name="viewport"]')?.getAttribute('content'),
      rewardPopupOpen: false,
      account: this.dom.root.getAttribute('data-user') ?? new URL(this.dom.root.getAttribute('src')).searchParams.get('usr'),
      autoOpenGame: this.dom.root.getAttribute('data-auto-open-game') ?? false,
      url: this.dom.root.getAttribute('data-url') ?? window.location.href,
      embedGame: this.dom.root.getAttribute('data-game') ?? null,
      rewardOnly: !!(this.dom.root.getAttribute('data-reward') ?? 0),
      useParentUrl: !!(this.dom.root.getAttribute('allow-parent-url') ?? 0),
      player: JSON.parse(localStorage?.getItem('KlujoFBUser') ?? '{}'),
      game: null,
      gameOpened: false
    }

    constructor() {
      addEventListener('message', this.observer.bind(this));

      this.dom.frame.classList.add('game-frame');
      this.dom.reward.classList.add('reward-popup', 'hidden');
      this.dom.close.classList.add('close-game');

      this.dom.top.insertAdjacentElement('afterbegin', this.dom.reward);
      !this.vars.rewardOnly && this.dom.top.insertAdjacentElement('afterbegin', this.dom.frame);

      if (!this.vars.autoOpenGame) {
        this.dom.top.insertAdjacentElement('afterbegin', this.dom.close);
      }
    }

    setGameId(gameId) {
      this.vars.game = Object.assign({}, this.vars.game, { public_id: gameId });
    }

    async api(call, payload) {
      const options = {};
      if (typeof payload === 'string') {
        call += `/${payload}`;
      } else if (payload instanceof URLSearchParams) {
        Object.assign(options, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: payload.toString(),
          method: 'post'
        });
      } else if (payload) {
        Object.assign(options, {
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json' },
          method: 'post'
        })
      }

      const response = await fetch(`${this.urls.api}${call}`, options);
      const data = await response.json();

      return data;
    }

    async findGame() {
      try {
        const params = new URLSearchParams({ 'source_url': this.vars.url });
        const gameId = parseInt(this.vars.embedGame, 10);

        if (!isNaN(gameId) && gameId > 0) params.set('game_id', gameId);

        const urlSearchParams = new URLSearchParams(params);
        const { game, player } = await this.api('game/' + this.vars.account, urlSearchParams);

        if (player) this.setPlayer.call(this, player);
        if (localStorage.getItem(game?.public_id) && !this.vars.autoOpenGame) {
          this.closeGame.call(this, { game: game.public_id, player });
        } else if (game) {
          Object.assign(this.vars, { game });
        }
      } catch (error) {
        console.error("Error: " + error.message);
      }
    }
    async fetchGame() {
      const request = new URLSearchParams({ 'source_url': window.location.href, 'account_id': this.vars.account });
      if (!this.vars.game?.public_id) return;
      if (this.vars.player?.email) request.set('email', this.vars.player.email);

      const response = await this.api('game-preview/' + this.vars.game.public_id, request);
      Object.assign(this.vars.game, response.game);
      this.dom.frame.src = `${this.urls.domain}game-embedder/${this.vars.game.public_id}/` + (this.vars.embedGame ? 'embed' : 'snippet');
    }
    addStyle() {
      const style = document.createElement('style');
      style.textContent = this.css;
      document.head.appendChild(style);
    }
    async getRewards() {
      const params = {
        'source_url': window.location.href,
        'player_id': this.vars.player?.public_id,
        'game_id': this.vars.game?.public_id,
        'account_id': this.vars.account,
        'reward_only': this.vars.rewardOnly
      }

      const request = new URLSearchParams(Object.entries(params).filter(([_, v]) => v));
      const result = await this.api('get-rewards', request);

      Object.assign(this.vars, { ...result });
      if (result.player) this.setPlayer.call(this, result.player);

      return Promise.resolve(result);
    }
    async addRewardFrame(params = {}) {
      const { rewards, rewardSettings, player } = params
      if (rewards.length) {
        const iframe = document.createElement('iframe')
        this.dom.rewardFrame = iframe
        this.dom.reward.appendChild(iframe)
        this.dom.top.appendChild(this.dom.reward)

        if (player) {
          this.setPlayer(player)
        }

        const url = new URL(`rewards/${this.vars.account}/${this.vars.player?.public_id ?? ''}`, this.urls.domain);
        url.searchParams.set('source_url', window.location.href);

        if (!this.vars.rewardOnly) {
          url.searchParams.set('show_all', 1);
        }
        
        if (this.vars.useParentUrl) {
          url.searchParams.set('parent_url', document.referrer);
        }

        Object.assign(iframe, { src: url.toString(), frameborder: 0, class: 'rewards-iframe' });
        this.vars.rewardUrl = iframe.src;

        return { rewardSettings, rewards, player };
      }
    }

    addRewardButton(params) {
      const { rewardSettings } = params;
      const openIcon = rewardSettings.button_icon ? `${this.urls.media}${rewardSettings.button_icon}` : `${this.urls.media}assets/images/reward_popup_button.png`;
      const closeIcon = `${this.urls.media}assets/images/reward_close.png`;

      const toggleButton = document.createElement('button')
      Object.assign(toggleButton, {
        id: 'toggleRewardsButton',
        className: 'toggl-button OpenButton',
        style: `
          z-index: 99999;
          background-color: ${rewardSettings.button_background_color};
          color: ${rewardSettings.button_text_color};
          position: fixed;
          bottom: 20px;
          left: 20px;
        `,
        innerHTML: `
          <img src="${openIcon}" class="OpenButton" />
          <span class="OpenButton">${rewardSettings.button_name}</span>
        `
      })
      this.dom.top.appendChild(toggleButton)

      const updateButtonState = (isOpen) => {
        toggleButton.style.backgroundColor = isOpen ?
          rewardSettings.button_background_color_active :
          rewardSettings.button_background_color
        const buttonImg = toggleButton.querySelector('img')
        buttonImg.src = isOpen ? closeIcon : openIcon
        toggleButton.querySelector('span').style.display = isOpen ? 'none' : 'inline'
        toggleButton.className = isOpen ? 'toggl-button closeButton' : 'toggl-button OpenButton'
      }

      toggleButton.addEventListener('click', () => {
        const isOpen = !this.dom.reward.classList.contains('hidden')
        this.dom.reward.classList.toggle('hidden')
        updateButtonState(!isOpen)
      })
      this.dom.toggle = toggleButton
    }

    bindHandlers() {
      if (!this.vars.game?.public_id) return
      if (this.vars.game.page_scroll) {
        this.addScrollListener()
      }
      if (this.vars.game.time_delay) {
        this.addDelayedGameShow()
      }
      if (this.vars.game.exit_intent) {
        this.addExitIntentListener()
      }
      if (this.vars.autoOpenGame) {
        this.showGame()
      }
    }

    addScrollListener() {
      const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = document.documentElement
        const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100
        if (scrollPercentage >= this.vars.game.page_scroll_percent && !this.vars.gameOpened) {
          window.removeEventListener('scroll', handleScroll)
          this.showGame()
        }
      }
      window.addEventListener('scroll', handleScroll, { passive: true })
    }

    addDelayedGameShow() {
      setTimeout(() => {
        if (!this.vars.gameOpened) {
          this.showGame()
        }
      }, this.vars.game.time_delay_second * 1000)
    }

    addExitIntentListener() {
      const handleMouseLeave = (event) => {
        if (event.clientY <= 0 && !this.vars.gameOpened) {
          document.removeEventListener('mouseleave', handleMouseLeave)
          this.showGame()
        }
      }
      const handleBlur = () => {
        if (!this.vars.gameOpened) {
          window.removeEventListener('blur', handleBlur)
          this.showGame()
        }
      }
      document.addEventListener('mouseleave', handleMouseLeave)
      window.addEventListener('blur', handleBlur)
    }

    addCloseButton() {
      if (this.dom.close.childElementCount > 0) return
      this.dom.close.innerHTML = `
        <img src="${this.urls.media}assets/images/close_gray.svg" />
      `
      this.dom.close.addEventListener('click', this.closeGame.bind(this, { game: this.vars.game.public_id }))
    }

    async showGame() {
      if (!this.vars.gameOpened && this.dom.frame.contentWindow) {
        this.dom.frame.contentWindow?.postMessage({ func: 'showGame' }, '*')
        this.dom.close.style.display = 'block'
        this.vars.gameOpened = true
        this.addCloseButton()
        this.dom.top.classList.add('game-open')
        document.head.querySelector('meta[name="viewport"]')?.setAttribute('content', 'width=device-width,height=device-height,initial-scale=1.0,user-scalable=no,maximum-scale=1.0,minimum-scale=1.0')
      }

      if (!this.vars.autoOpenGame && !this.vars.player?.public_id) {
        const response = await this.api('game-analytics', {
          game_public_id: this.vars.game.public_id,
          action: 'view',
          player_id: 0
        })
      }
    }
    updateRewardPopup() {
      this.dom.rewardFrame.remove()
      this.dom.rewardFrame = null
      this.addRewardFrame({ ...this.vars }).then(console.log).catch(console.error)
    }
    OpenRewardWidget() {
      this.dom.toggle.click()
    }
    setPlayer(args) {
      if (args?.public_id) {
        localStorage.setItem('KlujoFBUser', JSON.stringify(args))
        this.dom.rewardFrame?.contentWindow?.postMessage({ func: 'updateFBUser', data: args }, '*')
        if (this.vars.player?.public_id !== args.public_id || (this.vars.player.score !== args.score)) {
          this.vars.player = args
          if (args.played) {
            localStorage.setItem(this.vars.game?.public_id, Date.now())
          }
          this.dom.rewardFrame && this.updateRewardPopup()
        }
      }
    }
    closeGame(args) {
      this.dom.top.classList.remove('game-open')
      let { game, player } = args
      if (game && this.dom.frame) {
        this.dom.frame.contentWindow?.postMessage({ func: 'closeGame' }, '*')
        this.dom.frame.remove()
        this.dom.close.remove()
        localStorage.setItem(game, Date.now())
      }
      if (player) {
        this.setPlayer.call(this, player)
      }
      document.head.querySelector('meta[name="viewport"]')?.setAttribute('content', this.vars.viewport)
    }

    addRewards(args) {
      // console.log({ addRewards: args })
      // console.log(this)
    }

    async addEmbeddedGame() {
      var encodedUrl = btoa(window.location.href),
        iframeSrc = `${this.urls.embed}${this.vars.account}/` + encodedUrl;

      document.querySelectorAll(".embedded-klujo").forEach(function (e) {
        if (!e.querySelector("iframe")) {
          var i = document.createElement("iframe");
          i.src = iframeSrc + '/' + e.getAttribute("data-id")
          i.style.width = "100%";
          i.style.height = "100%";
          i.style.minHeight = "800px";
          i.style.minWidth = "340px";
          i.style.borderRadius = "14px";
          i.style.border = "0";

          e.appendChild(i);
        }
      });
    }

    async run() {
      this.addStyle()
      if (!this.vars.rewardOnly) {
        await this.findGame()
          .then(this.fetchGame.bind(this))
          .then(this.bindHandlers.bind(this))
          .catch(console.error)
      }

      if (!this.vars.autoOpenGame) {
        await this.getRewards()
          .then(this.addRewardFrame.bind(this))
          .then(this.addRewardButton.bind(this))
          .catch(console.error)
      }

      this.addEmbeddedGame()
    }
    observer(message) {
      const { data, func } = message.data
      if (func && typeof this[func] === 'function') {
        this[func].call(this, data)
      }
    }
  }

  const app = new KlujoSnippet();
  await app.run();

  console.log('SnippetVersion', import.meta.env.VITE_APP_VERSION);
})()
